import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import SendIcon from "@mui/icons-material/Send";
import { useLocation, useNavigate } from "react-router-dom";

const DefectDistribution = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const chartCategories = [
    "By Severity",
    "By Priority",
    "RCA",
    "Overall Defects by Status",
  ];

  const [selectedCharts, setSelectedCharts] = useState(
    Object.fromEntries(chartCategories.map((category) => [category, ""]))
  );

  const handleChartSelection = (category, value) => {
    setSelectedCharts((prev) => ({ ...prev, [category]: value }));
  };

  const allFieldsFilled = Object.values(selectedCharts).every(
    (value) => value !== ""
  );

  const renderChartOptions = (category) => (
    <RadioGroup
      row
      sx={{ display: "flex", gap: 3 }}
      value={selectedCharts[category] || ""}
      onChange={(e) => handleChartSelection(category, e.target.value)}
    >
      {["Bar Chart", "Line Chart", "Pie Chart"].map((label) => (
        <Box
          key={label}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "2px solid #ccc",
            borderRadius: "9px",
            padding: "4px 8px",
            cursor: "pointer",
            minWidth: "130px",
            height: "30px",
            justifyContent: "center",
            "&.Mui-selected, &:has(input:checked)": {
              borderColor: "#007bff",
              backgroundColor: "#FFFFFF",
            },
          }}
        >
          <FormControlLabel
            value={label.toLowerCase().replace(" ", "-")}
            control={<Radio />}
            label={label}
          />
        </Box>
      ))}
    </RadioGroup>
  );

  const handleDefectDistributionNext = () => {
    console.log("Selected Charts: ", selectedCharts);
    try {
      // Add your logic here
      let defectDistributionData = {
        selectedCharts: selectedCharts,
      };
      navigate("/dashboard/sprint-summary-report/output", {
        state: {
          ...location.state,
          defectDistributionData: defectDistributionData,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleFormLoadDemoExample = (e) => {
    e.stopPropagation();
    // Add your logic here
    setSelectedCharts({
      "By Severity": "bar-chart",
      "By Priority": "line-chart",
      RCA: "pie-chart",
      "Overall Defects by Status": "bar-chart",
    });
  };

  return (
    <CommonAccordion
      summary={
        <Box
          display="flex"
          alignItems="center"
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography variant="subtitle1" sx={{ fontSize: "16px" }}>
            Defect Distribution
          </Typography>
          <Button
            variant="text"
            startIcon={<LoadIcon />}
            sx={{
              ml: 2,
              textTransform: "none",
              position: "relative",
              top: "0px",
            }}
            onClick={handleFormLoadDemoExample}
          >
            Load Demo Example
          </Button>
        </Box>
      }
      details={
        <Box>
          <Box
            sx={{
              mt: 2,
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px dashed #49A3FF",
              borderRadius: "8px",
              padding: "14px",
              cursor: "pointer",
              width: "85%",
              backgroundColor: "#F8FBFF",
              color: "#000",
              fontSize: "14px",
              fontWeight: 500,
              gap: 1.5,
            }}
          >
            <ContentPasteSearchIcon sx={{ fontSize: 28, color: "#333" }} />
            <Box>
              <Typography variant="body1">Import Defects Data</Typography>
              <Typography variant="body2" sx={{ color: "grey.600" }}>
                Swagger, Postman Collection, etc.
              </Typography>
            </Box>
          </Box>
          {chartCategories.map((label) => (
            <Box key={label} mb={3}>
              <Typography variant="subtitle2" gutterBottom>
                {label}
              </Typography>
              {renderChartOptions(label)}
            </Box>
          ))}
        </Box>
      }
      buttons={[
        {
          label: "Next",
          variant: "contained",
          startIcon: <SendIcon />,
          onClick: handleDefectDistributionNext,
          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: allFieldsFilled ? "#49A3FF" : "grey",
            color: allFieldsFilled ? "white" : "black",
            "&:hover": {
              backgroundColor: allFieldsFilled ? "#49A3FF" : "darkgrey",
            },
          },
          disabled: !allFieldsFilled,
        },
      ]}
    />
  );
};

export default DefectDistribution;
